<template>
  <div>
    <div class="search-filters-header">
      <div class="header-title">
        Study Statistics
      </div>
    </div>
    <div class="card search-filters-card">
      <div class="card-body search-filters-card-body">
        <b-collapse
            class="w-100"
            id="collapse-2"
            v-model="collapsed"
        >
          <div class="row">
            <div class="col-6 d-flex flex-column align-items-center">
              <div class="input-wrapper">
                <label>Are the binary scale questions 0-1 or 1-2?</label>
                <el-select
                  v-model="binary_questions"
                  collapse-tags
                  placeholder="0 and 1"
                  required
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in binary_questions_options"
                      :key="value"
                      :label="value"
                      :value="value"
                    >
                      <span style="float: left">{{value}}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div class="input-wrapper">
                <label>Select the main question Column (OOF) *</label>
                <el-select
                  v-model="main_question_column"
                  collapse-tags
                  placeholder="Select values"
                  required
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in main_question_column_options"
                      :key="value"
                      :label="value"
                      :value="value"
                    >
                      <span style="float: left">{{value}}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div class="input-wrapper">
                <label>Select how the order of the products will be displayed in the result *</label>
                <el-select
                  v-model="order_of_products"
                  collapse-tags
                  placeholder="Select values"
                  required
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in order_of_products_options"
                      :key="value"
                      :label="value"
                      :value="value"
                    >
                      <span style="float: left">{{value}}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div class="input-wrapper">
                <label>Select the strength questions (multiple optional)</label>
                <el-select
                  v-model="strength_questions"
                  collapse-tags
                  placeholder="Select values"
                  multiple
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in strength_questions_options"
                      :key="value"
                      :label="value"
                      :value="value"
                    >
                      <span style="float: left">{{value}}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div class="input-wrapper">
                <label>
                  Select the
                  <span v-b-tooltip.hover.html="'Consumer Perceived Value'" style="text-decoration: underline">
                    CPV
                  </span>
                  questions. Can select multiple, only for 5 point scale</label>

                <el-select
                  v-model="cpv_questions"
                  collapse-tags
                  placeholder="Select values"
                  multiple
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in cpv_questions_options"
                      :key="value"
                      :label="value"
                      :value="value"
                    >
                      <span style="float: left">{{value}}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div class="mt-1 w-100 d-flex">
                <div
                  class="edit-label mr-2"
                  :class="{ active: replace_codes_to_name }"
                >
                  Do you want to replace product codes to product name?
                </div>
                <ToggleButton
                  class="toggle-switch mt-1"
                  :width="26"
                  :height="14"
                  :sync="true"
                  v-model="replace_codes_to_name"
                ></ToggleButton>
              </div>
              <div class="mt-1 w-100 d-flex">
                <div
                  class="edit-label mr-2"
                  :class="{ active: use_charts }"
                >
                  Do you need Charts?
                </div>
                <ToggleButton
                  class="toggle-switch mt-1"
                  :width="26"
                  :height="14"
                  :sync="true"
                  v-model="use_charts"
                ></ToggleButton>
              </div>
            </div>
            <div class="col-6 d-flex flex-column align-items-center">
              <div class="input-wrapper">
                <label>Project Number / Name / CMI</label>
                <el-input
                  placeholder="Input data"
                  v-model="project"
                  clearable
                />
              </div>
              <div class="input-wrapper">
                <label>Category</label>
                <el-select
                  v-model="category"
                  collapse-tags
                  placeholder="Select values"
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in category_options"
                      :key="value"
                      :label="value"
                      :value="value"
                    >
                      <span style="float: left">{{value}}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div class="input-wrapper">
                <label>Types of test needed. Multiple selected</label>
                <el-select
                  v-model="test_types"
                  collapse-tags
                  placeholder="Select values"
                  multiple
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="value in test_types_options"
                      :key="value"
                      :label="value"
                      :value="value"
                    >
                      <span style="float: left">{{value}}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div class="mt-1 w-100 d-flex">
                <div
                  class="edit-label mr-2"
                  :class="{ active: regression }"
                >
                  Do you require regression
                </div>
                <ToggleButton
                  class="toggle-switch mt-1"
                  :width="26"
                  :height="14"
                  :sync="true"
                  v-model="regression"
                ></ToggleButton>
              </div>
              <div class="mt-1 w-100 d-flex">
                <div
                  class="edit-label mr-2"
                  :class="{ active: parametric }"
                >
                  Parametric or non-Parametric test
                </div>
                <ToggleButton
                  class="toggle-switch mt-1"
                  :width="26"
                  :height="14"
                  :sync="true"
                  v-model="parametric"
                ></ToggleButton>
              </div>
            </div>
          </div>
        </b-collapse>
        <div class="row">
          <div class="col-6 search-filters-actions-wrapper" />
          <div class="col-6 search-filters-actions-wrapper">
            <button
              class="search-button btn"
              type="button"
              @click="() => search()"
            >
              Search
            </button>
            <div class="open-filter-button" @click="toggleFiltersCollapse">
              <font-awesome-icon :icon="collapsed ? 'expand' : 'compress'"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card search-filters-card mt-5" v-if="!collapsed">
      <div class="card-body search-filters-card-body">
        <div class="row">
          <div class="col-6">
            <div class="results-header">
              <div class="results-header__title">Express AG Salon Line CMI Support</div>
            </div>
            <div class="fragrances-container">
              <div class="fragrances-wrapper">
                <div
                  class="
                    data data-hide data-header
                    d-flex
                    flex-row
                    justify-content-between
                    align-items-center
                  "
                >
                  <div class="align-items-center fragrance-label metric-value"/>
                  <div class="align-items-center fragrance-data-cell metric-value">A (MANGO FIZZ RW02)</div>
                  <div class="align-items-center fragrance-data-cell metric-value">B (BERRY GLORY RW01)</div>
                  <div class="align-items-center fragrance-data-cell metric-value">C (SHAMPOO KIWI EXPRESS)</div>
                </div>
                <RecycleScroller
                  class="scroller"
                  :items="filteredDataSalonLine"
                  :item-size="40"
                  keyField="id"
                  :emit-update="true"
                  v-slot="{ item }"
                >
                  <div
                    class="
                      data data-hide
                      d-flex
                      flex-row
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div class="align-items-center fragrance-label metric-value">{{ item.label }}%</div>
                    <div class="align-items-center fragrance-data-cell metric-value">{{ item.mango }}%</div>
                    <div class="align-items-center fragrance-data-cell metric-value">{{ item.berry }}%</div>
                    <div class="align-items-center fragrance-data-cell metric-value">{{ item.kiwi }}%</div>
                  </div>
                </RecycleScroller>
              </div>
            </div>
            <div class="results-header">
              <div class="results-header__title">Correlations</div>
            </div>
            <div class="fragrances-container">
              <div class="fragrances-wrapper">
                <div
                  class="
                    data data-hide data-header
                    d-flex
                    flex-row
                    justify-content-between
                    align-items-center
                  "
                >
                  <div class="align-items-center correlations-data-cell metric-value">Q</div>
                  <div
                    class="align-items-center correlations-data-cell metric-value"
                    v-for="quarter in quarters"
                    :key="quarter"
                  >
                    {{ quarter }}
                  </div>
                </div>
                <RecycleScroller
                  class="scroller"
                  :items="filteredDataCorrelations"
                  :item-size="40"
                  keyField="quarter"
                  :emit-update="true"
                  v-slot="{ item }"
                >
                  <div
                    class="
                      data data-hide
                      d-flex
                      flex-row
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div
                      class="align-items-center correlations-data-cell metric-value"
                      style="width: 50px !important"
                      v-for="data in Object.values(item)"
                      :key="`${index}-${data}`"
                    >
                      {{ data || '-' }}
                    </div>
                  </div>
                </RecycleScroller>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div
              class="d-flex align-items-center"
            >
              <div class="row">
                <div class="input-wrapper row">
                  <div class="col-6 search-filters-actions-wrapper">
                    <label>Question</label>
                    <el-select
                      v-model="question"
                      collapse-tags
                      placeholder="Select question"
                      multiple
                    >
                      <el-option-group label="Press Tab/Escape to exit">
                        <el-option
                          v-for="value in question_options"
                          :key="value"
                          :label="value"
                          :value="value"
                        >
                          <span style="float: left">{{value}}</span>
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </div>
                  <div class="col-6 search-filters-actions-wrapper">
                    <button
                      class="search-button btn"
                      type="button"
                    >
                      Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="results-header">
              <div class="results-header__title">Statistics Results</div>
              <img
                src="../assets/images/icons/excel-export-H.svg"
                class="dwn-button"
              />
              <el-select
                class="select-group-item"
                :placeholder="`Filter results`"
                filterable
                collapse-tags
                multiple
                v-model="result_filters"
              >
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option
                    v-for="value in result_filters_options"
                    :key="value"
                    :value="value"
                    :label="value"
                  >
                    <span style="float: left">
                      {{value}}
                    </span>
                  </el-option>
                </el-option-group>
              </el-select>
            </div>

            <div class="charts-container d-flex flex-column align-items-center">
              <HorizontalAnalyticsChart
                v-for="(item, idx) in ChartData"
                :key="`chart-${idx}`"
                :data="item"
                :mean="item.mean"
                :n-values="item.counts"
              ></HorizontalAnalyticsChart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import ToggleButton from '@/components/shared/ToggleButton'
import HorizontalAnalyticsChart from '../components/shared/HorizontalAnalyticsChart'
import { mapActions } from 'vuex'
import statisticsActions from '../store/modules/statistics/actionTypes'

export default {
  name: 'StudyStatistics',
  components: {
    ToggleButton,
    HorizontalAnalyticsChart
  },
  data () {
    return {
      binary_questions: '',
      binary_questions_options: ['0-1', '1-2'],
      main_question_column: '',
      main_question_column_options: ['main_question_column_1', 'main_question_column_2'],
      order_of_products: '',
      order_of_products_options: ['order_of_products_1', 'order_of_products_2'],
      strength_questions: [],
      strength_questions_options: ['strength_questions_1', 'strength_questions_2'],
      cpv_questions: [],
      cpv_questions_options: ['cpv_questions_1', 'cpv_questions_2'],
      project: '',
      category: '',
      category_options: ['category_1', 'category_2'],
      test_types: '',
      test_types_options: ['category_1', 'category_2'],
      regression: false,
      parametric: false,
      use_charts: false,
      replace_codes_to_name: false,
      collapsed: true,
      result_filters: [],
      result_filters_options: ['result_filters_1', 'result_filters_2'],
      question: '',
      question_options: ['question_1', 'question_2'],
      quarters: ['Q1', 'Q2', 'Q3', 'Q4', 'Q5'],
      chart: {
        options: {
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  min: 0,
                  callback: function (val) {
                    return val % 1 === 0 ? val : null
                  }
                }
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''

                let value = Number(data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ])
                if (isNaN(value)) {
                  value = 0
                }
                label = label.split('.')[0]
                return label + ': ' + `${value.toFixed()}`
              },
              title: function (tooltipItem, data) {
                let label = data.labels[tooltipItem[0].index]
                let nextLabel = data.labels[tooltipItem[0].index + 1]
                if (nextLabel) {
                  label += ' - ' + nextLabel
                } else {
                  const step = Number(data.labels[1]) - Number(data.labels[0])
                  label += ' - ' + (Number(label) + step).toFixed(2)
                }
                return label
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      filteredDataSalonLine: [
        {
          id: 1,
          label: 'Q.1 - (1)',
          mango: 27,
          berry: 27,
          kiwi: 27
        },
        {
          id: 2,
          label: 'Q.2 - (2)',
          mango: 27,
          berry: 27,
          kiwi: 27
        },
        {
          id: 3,
          label: 'Q.3 - (3)',
          mango: 27,
          berry: 27,
          kiwi: 27
        },
        {
          id: 4,
          label: 'Q.4 - (4)',
          mango: 27,
          berry: 27,
          kiwi: 27
        },
        {
          id: 5,
          label: 'Q.5 - (5)',
          mango: 27,
          berry: 27,
          kiwi: 27
        },
        {
          id: 6,
          label: 'Q.6 - (6)',
          mango: 27,
          berry: 27,
          kiwi: 27
        },
        {
          id: 7,
          label: 'Q.7 - (7)',
          mango: 27,
          berry: 27,
          kiwi: 27
        }
      ],
      filteredDataCorrelations: [
        {
          quarter: 'Q1',
          'Q1': undefined,
          'Q2': undefined,
          'Q3': 0.1,
          'Q4': undefined,
          'Q5': undefined
        },
        {
          quarter: 'Q2',
          'Q1': undefined,
          'Q2': undefined,
          'Q3': 0.1,
          'Q4': undefined,
          'Q5': undefined
        },
        {
          quarter: 'Q3',
          'Q1': undefined,
          'Q2': undefined,
          'Q3': 0.1,
          'Q4': undefined,
          'Q5': undefined
        },
        {
          quarter: 'Q4',
          'Q1': undefined,
          'Q2': undefined,
          'Q3': 0.1,
          'Q4': undefined,
          'Q5': undefined
        },
        {
          quarter: 'Q5',
          'Q1': undefined,
          'Q2': undefined,
          'Q3': 0.1,
          'Q4': undefined,
          'Q5': undefined
        }
      ]
    }
  },
  computed: {
    ChartData () {
      return [{
        mean: 20,
        counts: [10, 20, 30],
        labels: ['Top 2 box', 'Neutral', 'Bottom 2 box'],
        datasets: [
          {
            label: 'Liking',
            backgroundColor: 'rgba(163,160,251,0.5)',
            data: [10, 20, 30]
          }
        ]
      }, {
        mean: 30,
        counts: [10, 20, 30],
        labels: ['Top 2 box', 'Neutral', 'Bottom 2 box'],
        datasets: [
          {
            label: 'Purchase intention',
            backgroundColor: 'rgba(163,160,251,0.5)',
            data: [20, 30, 40]
          }
        ]
      }, {
        mean: 40,
        counts: [10, 20, 30],
        labels: ['Top 2 box', 'Neutral', 'Bottom 2 box'],
        datasets: [
          {
            label: 'Example',
            backgroundColor: 'rgba(163,160,251,0.5)',
            data: [30, 40, 50]
          }
        ]
      }]
    }
  },
  methods: {
    ...mapActions({
      generateStatisticsResults: statisticsActions.FETCH_STATISTICS
    }),
    toggleFiltersCollapse () {
      this.collapsed = !this.collapsed
    },
    async search () {
      // this.collapsed = false
      console.log('search statistics')
      const response = await this.generateStatisticsResults(
        1,
        {}
      )
      console.log('----------')
      console.log(response)
      console.log('----------')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.search-filters-header {
  height: 160px;
  width: 100%;
  background: transparent linear-gradient(266deg, rgba(115,178,224, 0.73) 0%, rgba(0,39,204, 0.73) 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  border: 1px solid #231A44;
  border-left: 0;
  border-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 34px;
  padding-top: 13px;
  position: relative;

  .header-title {
    width: 500px;
    height: 56px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 45px;
    line-height: 30px;
    font-weight: 900;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    color: white;
    white-space: nowrap;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header-subtitle {
    height: 30px;
    color: white;
    font-family: 'Open Sans', sans-serif;
    font-size: 22px;
    line-height: 30px;
    letter-spacing: 0;
    margin-bottom: 56px;
  }

  .filter-tabs-wrapper {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: -1px;
    right: 0;
    z-index: 3;
    width: 100%;
    padding-right: 80px;

    .filters-tab {
      max-width: 240px;
      width: 100%;
      height: 44px;
      color: $dusty-blue;
      border: 1px solid #25232C;
      background-color: $silver;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 20px;
      line-height: 25px;
      letter-spacing: 0;
      cursor: pointer;
      border-left: 0;

      &:first-of-type {
        border-left: 1px solid #25232C;
      }
    }

    .saved-searches-toggle {
      position: absolute;
      width: 80px;
      transition: right 0.35s ease-in-out;
      background-color: #3981FF;
      bottom: 0;
      border-left: 1px solid #25232C;
      border-right: 1px solid #25232C;
    }

    .selected {
      border-bottom: 0;
      background-color: $light-grey !important;
      font-weight: 900;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        width: 80%;
        left: 10%; /*this centers it based on the above width*/
        border-bottom: 2px solid $dusty-blue;
      }
    }
  }
}

.search-filters-card {
  margin-bottom: 0;
  box-shadow: 0 5px 7px #999999;
  background-color: $light-grey;
  border: 0;

  .search-filters-actions-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 582px;
    height: 118px;
    align-self: flex-end;
    margin-top: 15px;

    .search-button {
      width: 100%;
      max-width: 230px;
      height: 48px;
      background-color: $blueberry;
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 800;
      line-height: 30px;
      letter-spacing: 0;
      border-radius: 4px;
      color: white;
      text-transform: uppercase;

      transition: background-color 0.2s linear;

      &:hover {
        background-color: #9256D9;
      }
    }

    .search-button-alt {
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0;
      width: 100%;
      max-width: 230px;
      height: 48px;
      background-color: #F8F8F8;
      border-radius: 4px;
      color: $button-text;
      text-transform: uppercase;
      transition: all 0.2s linear;
      margin-right: 30px;

      &:hover {
        border-color: #dedede;
        background-color: white;
      }
    }
  }
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}

.search-filters-card {
  .search-filters-actions-wrapper {

    .el-input-group__append {
      color: white !important;
      cursor: pointer;
      padding: 0 !important;
      border: 0 !important;

      div {
        background-color: $active-link;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 1px 8px;
        height: 100%;
      }
    }
  }
}

.open-filter-button {
  position: absolute;
  bottom: 24px;
  right: 24px;
  font-size: 35px;
  line-height: 35px;
  height: 35px;
  color: $home-card;
  cursor: pointer;
  transition: color 0.2s linear;

  &:hover {
    color: $navbar-dropdown-text
  }
}

.results-header {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 20px 66px 10px;
  width: 100%;
  border-top: 1px solid #25232c;

  &__title {
    color: #545772;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Source Sans Pro", sans-serif;
    font-size: 24px;
    text-transform: uppercase;
    line-height: 28px;
    letter-spacing: 0;
    font-weight: 900;
  }
}

.scroller {
  overflow-x: visible;
  overflow-y: unset;
  height: 400px;
}

.fragrances-container {
  height: 400px;
  overflow-x: auto;
}

.fragrances-wrapper {
  height: 100%;
  width: 100%;
}

.fragrance-data-cell {
  min-width: 190px;
  max-width: 190px;
}

.correlations-data-cell {
  min-width: 90px;
  max-width: 90px;
}

.fragrance-label {
  min-width: 50px;
  max-width: 50px;
}

.vue-recycle-scroller {
  width: 100%;
}

.data {
  border-bottom: 1px solid #d1d4d7;
  transition: 0.1s background-color linear;
  padding: 0 10px;
}

.data:hover {
  background-color: #f6f6f6;
}

.metric-value {
  text-align: center;
  width: auto;
  padding: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

active {
  color: #78bb95;
}
</style>
